import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store';
import LogoutButton from './LogoutButton';
import Section from './components/Section';
import Item from './components/Item';
import {
    FiHome,
    FiLayers,
    FiUsers,
    FiFileText,
    FiUpload,
    FiBriefcase,
    FiClipboard,
    FiMapPin,
    FiPackage,
    FiVideo,
    FiRadio,
    FiShoppingCart,
    FiLink,
    FiRefreshCw
} from 'react-icons/fi';
import { Accordion } from './components/Accordion';
import SidebarBankHeader from './components/SidebarBankHeader';

export default function BankSidebar() {
    const bank = useAppSelector((s) => s.user.bank);
    const location = useLocation();

    return (
        <div className="flex h-screen flex-col bg-white text-gray-900 dark:bg-[#0f172a] dark:text-white">
            <SidebarBankHeader
                title="Bank Menu"
                subtitle={
                    [bank?.companyName, bank?.companyId].filter(Boolean).join(' · ') ||
                    undefined
                }
            />
            <nav className="flex-1 overflow-y-auto p-2 text-sm">
                <Accordion defaultOpenId="branches">
                    <Section id="main" title="Main Menu" alwaysOpen>
                        <Item icon={FiHome} label="Dashboard" to="/dashboard" active={location.pathname === '/dashboard'} />
                    </Section>
                    <Section id="branches" title="Branches" subtitle="Manage Branch Information">
                        <Item icon={FiLayers} label="View Branches" to="/branches" active={location.pathname === '/branches'} />
                        <Item icon={FiMapPin} label="Locations" to="/locations" active={location.pathname === '/locations'} />
                    </Section>
                    <Section id="management" title="Management" subtitle="Manage Service Companies and PSOs">
                        <Item icon={FiUsers} label="Manage Vendors" to="/companies" active={location.pathname === '/companies'} />
                        <Item icon={FiUsers} label="Manage PSO" to="/pso" active={location.pathname === '/pso'} />
                        <Item icon={FiBriefcase} label="Manage Managers" to="/managers" active={location.pathname === '/managers'} />
                        <Item icon={FiUpload} label="Deployment Vendor" to="/deployments" active={location.pathname === '/deployments'} />
                    </Section>
                    <Section id="surveys" title="Manage Surveys" subtitle="Manage Survey Operations">
                        <Item icon={FiClipboard} label="Branch Surveys" to="/surveys" active={location.pathname === '/surveys'} />
                        <Item icon={FiMapPin} label="New Location Surveys" to="/new-location-surveys" active={location.pathname === '/new-location-surveys'} />
                        <Item icon={FiRefreshCw} label="Lease Renewal Surveys" to="/lease-renewal-surveys" active={location.pathname === '/lease-renewal-surveys'} />
                    </Section>
                    <Section id="request" title="Request" subtitle="Manage Request Forms" alwaysOpen>
                        <Item icon={FiFileText} label="Request Form" to="/request-form" active={location.pathname === '/request-form'} />
                        <Item icon={FiFileText} label="Travelling Approval" to="/travelling-approval" active={location.pathname === '/travelling-approval'} />
                        <Item icon={FiRefreshCw} label="Change of Vendor" to="/change-of-vendor" active={location.pathname === '/change-of-vendor'} />
                    </Section>
                    <Section id="inventory" title="Manage Items" subtitle="Track and Manage Items">
                        <Item 
                            icon={FiPackage} 
                            label="CCTV Items" 
                            to="/inventory?category=CCTV" 
                            active={location.pathname === '/inventory' && new URLSearchParams(location.search).get('category') === 'CCTV'} 
                        />
                        <Item 
                            icon={FiPackage} 
                            label="BAMS Items" 
                            to="/inventory?category=BAMS" 
                            active={location.pathname === '/inventory' && new URLSearchParams(location.search).get('category') === 'BAMS'} 
                        />
                    </Section>
                    <Section id="manage-hardware" title="Manage Hardware" subtitle="Track Hardware Installations and Shipments">
                        <Item icon={FiVideo} label="CCTV Hardware" to="/manage-hardware-cctv" active={location.pathname === '/manage-hardware-cctv'} />
                        <Item icon={FiRadio} label="BAMS Hardware" to="/manage-hardware-bams" active={location.pathname === '/manage-hardware-bams'} />
                    </Section>
                    <Section id="hardware" title="Hardware Request" subtitle="Manage CCTV and BAMS Hardware Requests">
                        <Item icon={FiVideo} label="CCTV" to="/cctv" active={location.pathname === '/cctv'} />
                        <Item icon={FiRadio} label="BAMS" to="/bams" active={location.pathname === '/bams'} />
                    </Section>
                    <Section id="purchase-order" title="Purchase Order" subtitle="Manage Purchase Orders">
                        <Item icon={FiShoppingCart} label="PO CCTV" to="/po-cctv" active={location.pathname === '/po-cctv'} />
                        <Item icon={FiShoppingCart} label="PO BAMS" to="/po-bams" active={location.pathname === '/po-bams'} />
                    </Section>
                    <Section id="deploy" title="Deployment Management" subtitle="Manage Company Deployments">
                        <Item icon={FiUpload} label="Deploy Companies" to="/deployments" active={location.pathname === '/deployments'} />
                        <Item icon={FiFileText} label="View Deployments" to="/deployments" active={location.pathname === '/deployments'} />
                    </Section>
                </Accordion>
            </nav>
            <div className="shrink-0">
                <LogoutButton />
            </div>
        </div>
    );
}


